// src/context/DetailDialogContext.jsx

import React, {
    createContext,
    useCallback,
    useContext,
    useState
} from "react";
import DetailDialog from "../components/Dialog/DetailDialog";


const DetailDialogContext = createContext({
    showDetail: () => { }
});

export const DetailDialogProvider = ({ children }) => {
    const [opts, setOpts] = useState({ open: false });

    const showDetail = useCallback(({ title, maxWidth, children: dialogChildren, custActions, onCloseComplete }) => {
        setOpts({ open: true, title, maxWidth, dialogChildren, custActions, onCloseComplete });
    }, []);

    const closeDetail = useCallback(() => {
        setOpts(o => {
            if (typeof o.onCloseComplete === "function") {
                o.onCloseComplete();
            }
            return { ...o, open: false };
        });
    }, []);

    return (
        <DetailDialogContext.Provider value={{ showDetail }}>
            {children}
            {/* render the detail dialog */}
            <DetailDialog
                open={opts.open}
                title={opts.title}
                maxWidth={opts.maxWidth}
                custActions={opts?.custActions}
                onClose={closeDetail}
            >
                {opts.dialogChildren}
            </DetailDialog>
        </DetailDialogContext.Provider>
    );
};

export const useDetail = () => {
    const { showDetail } = useContext(DetailDialogContext);
    return showDetail;
};
